/**
 * Amen Atlas — Shared Constants
 * Used by both the public app and admin panel
 */

// =============================================================================
// SUPABASE
// =============================================================================

export const SUPABASE_URL = 'https://syzxotyomxttojanoavd.supabase.co';
export const SUPABASE_ANON_KEY = 'sb_publishable_pYhChh5weuEvkT2908bM0A_QHhwzMzq';

// =============================================================================
// GOSPEL TAGS — used to search Radio Browser API
// =============================================================================

export const GOSPEL_TAGS = [
  'gospel',
  'christian',
  'christian music',
  'worship',
  'christian contemporary',
  'christian rock',
  'christian talk',
  'religious',
];

// =============================================================================
// RADIO BROWSER API — multiple mirrors for failover
// =============================================================================

export const RADIO_BROWSER_SERVERS = [
  'https://de1.api.radio-browser.info',
  'https://de2.api.radio-browser.info',
  'https://at1.api.radio-browser.info',
  'https://nl1.api.radio-browser.info',
];

// =============================================================================
// APP CONFIG
// =============================================================================

export const APP_NAME = 'Amen Atlas';
export const APP_DESCRIPTION = 'Desbravar o planeta em busca de povos que louvam a Deus';
export const APP_VERSION = '1.0.0';

// Globe interaction
export const SNAP_RADIUS_PX = 40;           // Raio do crosshair visual (pixels)
export const TUNE_DEBOUNCE_MS = 200;         // Tempo de espera antes de tocar (ms)
export const GLOBE_AUTO_ROTATE_SPEED = 0.3;  // Rotação automática (graus/s)

// Cache
export const STATIONS_CACHE_TTL = 15 * 60 * 1000;  // 15 minutos em ms
export const STATIONS_CACHE_KEY = 'wwr_stations';

// Ads
export const AD_MIN_INTERVAL_MS = 5 * 60 * 1000;  // 5 min entre ads
export const AD_CLOSE_DELAY_MS = 3000;             // 3s antes do X aparecer

// Health check
export const HEALTH_CHECK_TIMEOUT_MS = 5000;       // 5s timeout por stream
export const HEALTH_CHECK_MAX_FAILURES = 3;        // falhas antes de marcar 'broken'

// Station sources
export const STATION_SOURCES = {
  RADIO_BROWSER: 'radio_browser',
  MANUAL: 'manual',
  SUGGESTION: 'suggestion',
};

// Station statuses
export const STATION_STATUSES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  BROKEN: 'broken',
};

// Suggestion statuses
export const SUGGESTION_STATUSES = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};
